import { RouteObject } from 'react-router-dom'

// Routes
const adminRoutes: RouteObject = {
  path: '/admin',
  lazy: async () => {
    const { default: Component } = await import('@src/app/pages/admin')
    return { element: <Component /> }
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/home')
        return { element: <Component /> }
      }
    },
    {
      path: 'users',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/user')
        return { element: <Component /> }
      }
    },
    {
      path: 'statistics/individual',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/individual-statistic')
        return { element: <Component /> }
      }
    },
    {
      path: 'statistics/unit',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/unit-statistic')
        return { element: <Component /> }
      }
    },
    {
      path: 'anti-cheat',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/anti-cheat')
        return { element: <Component /> }
      }
    },
    {
      path: 'essay-grading',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/essay-grading')
        return { element: <Component /> }
      }
    },
    {
      path: 'essay-grading/:participantId',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/essay-grading-detail')
        return { element: <Component /> }
      }
    },
    {
      path: 'exams',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/exam')
        return { element: <Component /> }
      }
    },
    {
      path: 'exams/:examId/templates',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/exam-templates')
        return { element: <Component /> }
      }
    },

    {
      path: 'exam-templates',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/exam-templates-list')
        return { element: <Component /> }
      }
    },
    {
      path: 'question-bank',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/question-bank')
        return { element: <Component /> }
      }
    },
    // {
    //   path: 'units',
    //   lazy: async () => {
    //     const { default: Component } = await import('@src/app/pages/admin/pages/unit')
    //     return { element: <Component /> }
    //   }
    // },
    {
      path: 'weekly-prize',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/weekly-prize')
        return { element: <Component /> }
      }
    },
    // {
    //   path: 'profile',
    //   lazy: async () => {
    //     const { default: Component } = await import('@src/app/pages/admin/pages/profile')
    //     return { element: <Component /> }
    //   }
    // },
    {
      path: 'content-management',
      lazy: async () => {
        const { default: Component } = await import('@src/app/pages/admin/pages/content-management')
        return { element: <Component /> }
      }
    }
  ]
}

export default adminRoutes
